module.exports = __webpack_public_path__ + "static/media/gaydon-lighthorne-heath-cropped.7e1b9d00.jpg";